.input {
    margin-bottom: var(--mantine-spacing-xs);
    flex: 2;
    border-radius: 0 var(--mantine-radius-md) var(--mantine-radius-md) 0;
}

.wrapper {
    flex: auto;
}

.container {
    width: 100%;
    display: flex;
    gap: 0;
    align-items: baseline;
}

.autocompleteWrapper {
    flex: 1;
    min-width: 0;
}

.inputWrapper {
    flex: 3;
    min-width: 0;
}
